import { Backdrop, CircularProgress } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";

const CustomBackdrop = ({ open }) => {
  return (
    <Backdrop style={{ zIndex: 1500 }} open={open}>
      <CircularProgress />
    </Backdrop>
  );
};
const mapStateToProps = (state) => ({
  open: state.backdrop,
});
export default connect(mapStateToProps)(CustomBackdrop);
